module.exports = __webpack_public_path__ + "img/5.1.12e1b10b.jpg";